import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { operators as Ops } from 'constants/application';

import { getViewData, getViewMeta } from 'views/modules/views';
import { ViewTable } from 'views/components';
import { getParams } from 'views/utils';

const LanesTab = () => {
  const dispatch = useDispatch();
  const views = useSelector(store => store.views);
  const lanes = views?.lanes;
  const init = lanes === undefined;

  useEffect(() => {
    if (init) {
      const overrides = {
        kilometers_at_risk: { type: 'kilometers_at_risk' },
        miles_at_risk: { type: 'miles_at_risk' },
      };
      dispatch(getViewMeta('lanes', overrides));
    }
  }, [dispatch, init]);

  const hasMeta = lanes?.meta?.allowed !== undefined;
  const { id: threatId = null } = useParams();
  const { search: url } = useSelector(store => store.router.location);
  const units = useSelector(store => store.account?.account?.prefs?.units?.default);

  const query = useMemo(() => {
    if (!hasMeta || !units) {
      return null;
    }

    const params = getParams(url, ['channel', 'mixpanel_event']);
    const filters = [
      ...params.filters,
      {
        name: 'threat_id',
        operator: Ops.exact,
        value: threatId,
      },
    ];
    const distanceRiskCol = units === 'imperial' ? 'miles_at_risk' : 'kilometers_at_risk';
    const distanceCol = units === 'imperial' ? 'total_miles' : 'total_kilometers';
    return {
      columns: ['lane', 'origin', 'destination', distanceCol, distanceRiskCol, 'risk'],
      ...params,
      filters,
      limit: 10,
    };
  }, [hasMeta, threatId, url, units]);

  useEffect(() => {
    if (query !== null) {
      dispatch(getViewData('lanes', query));
    }
  }, [dispatch, query]);

  const push = () => {};
  if (lanes?.items === undefined) {
    return null;
  }
  const getRowId = row => row.lane.id;
  return <ViewTable data={lanes} push={push} rowKey={getRowId} />;
};

export default LanesTab;
